<template>
  <div class="examlistItem">
    <div class="mockexamfor" v-for="(item, index) in examList" :key="index">
      <div class="left_mocktxt">
        <p class="titmock txt-line1">{{ item.title }}</p>
        <p class="textmock">
          <span class="mockdes">时长：</span>
          <span class="mockdesc2">{{ item.totalTime }}分钟</span>
          <span class="mockdes scoretotal">总分：</span>
          <span class="mockdesc2">{{ item.totalScore }}分</span>
          <span v-if="myexam == true" class="mockdes scoretotal">得分：</span>
          <span v-if="myexam == true" class="mockdesc2">{{ item.maxScore || 0 }}分</span>
        </p>
        <p class="textmock2">
          <span class="mockdes">考试须知：</span>
          <span class="mockdesc2">{{ item.content }}</span>
        </p>
      </div>
      <div class="rig_mockImg" v-if="myexam == true" @click="detailshijuan(item)">
        <img src="@/assets/images/viewexam.png" alt="" />
        <p>查看试卷</p>
      </div>
      <div class="rig_mockImg" v-else @click="examdetails(item)">
        <img src="@/assets/images/examination.png" alt="" />
        <p>开始考试</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "examlistItem",
  data() {
    return {};
  },
  props: {
    examList: {
      type: Array,
      default: [],
    },
    myexam: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  mounted() {},
  methods: {
    //考试详情
    examdetails(item) {
      let rourl = this.$router.resolve({
        path: "/mockdetails",
        query: { id: item.id, totalexam: item.totalTime },
      });
      window.open(rourl.href);
    },
    //查看试卷
    detailshijuan(item) {
      let rourl = this.$router.resolve({
        path: "/mypaper",
        query: {
          id: item.id,
          totalexam: item.totalTime,
          examstate: 1,
          paperId: item.paperId,
        },
      });
      window.open(rourl.href);
    },
  },
};
</script>
<style lang="scss" scoped>
.examlistItem {
  overflow: hidden;
  .mockexamfor {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #eeeeee;
    overflow: hidden;
    &:hover {
      box-shadow: 0px 0px 16px 0px rgba(155, 155, 155, 0.21);
    }
    .left_mocktxt {
      width: 90%;
      float: left;
      .titmock {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
      .textmock {
        padding: 18px 0 10px 0;
        font-size: 14px;
        .mockdes {
          font-weight: 400;
          color: #666666;
        }
        .scoretotal {
          margin-left: 60px;
        }
        .mockdesc2 {
          color: #666666;
        }
      }
      .textmock2 {
        font-size: 14px;
        padding: 0;
        color: #B18227;
      }
    }
    .rig_mockImg {
      text-align: center;
      margin-top: 12px;
      float: right;
      cursor: pointer;
      img {
        margin: 0 auto;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #1d4434;
        padding: 6px 0;
      }
    }
  }
  .mockexamfor:last-child {
    border-bottom: 1px solid #eeeeee;
  }
}
</style>
